<template>
  <div class="productos">
    <div class="titulo-seccion">
        <div class="datos-del-cliente">Productos</div>
    </div>
    <div class="frame-parent">
        <div class="magebar-code-scan-parent">
            <div class="magebar-code-scan">
                <img class="vector-icon" alt="" src="../assets/Vector.svg">

            </div>
            <div class="caja-de-texto">
              <CdAutocomplete
                :items="products"
                :return-object="true"
                item-value="commercialCode"
                item-text="description"
                :filter="customFilter"
                v-model="product"
              ></CdAutocomplete>
            </div>
            <img v-if="false" class="group-icon" alt="" src="../assets/Group.svg">
        </div>
        <div class="desplegables" v-if="false">
            <div class="desplegable">Desplegable</div>
            <img class="icon-chevron" alt="" src="Icon / Chevron.svg">
        </div>
        <div class="cantidad-parent">
            <div class="cantidad">{{ product && product.unit === 'm²' ? 'Total m²' : 'Cantidad' }}:</div>
            <div class="wrapper">
              <input type="number" :readonly="product && product.unit === 'm²'" class="input-texto-quantity" v-model="quantity">
            </div>
        </div>
    </div>
    <div class="frame-group" v-if="product && product.unit === 'm²'">
        <div class="ancho-parent">
            <div class="cantidad">Ancho</div>
            <div style="width: 55px; padding-right: 4px;" class="container">
              <input type="number" class="div" style="outline: none;border: none; width: 100%;text-align: right;" v-model="length" />
            </div>
            <div class="cantidad">m</div>
        </div>
        <div class="ancho-parent">
            <div class="cantidad">Largo</div>
            <div style="width: 55px; padding-right: 4px;" class="container">
              <input type="number" class="div" style="outline: none;border: none; width: 100%;text-align: right;" v-model="width" />
            </div>
            <div class="cantidad">m</div>
        </div>
        <div class="ancho-parent">
            <div class="cantidad">Cantidad</div>
            <div style="width: 55px; padding-right: 4px;" class="container">
              <input type="number" class="div" style="outline: none;border: none; width: 100%;text-align: right;" v-model="quantityM2" />
            </div>
            <div class="cantidad">unidades</div>
        </div>
    </div>
    <hr style="height: 0px; align-self: stretch; stroke-width: 1.5px; stroke: var(--Lineas-de-seccion, #E5EAFF);">

    <CustomizationAddProduct v-if="product && product.customization && product.customization.length > 0" :fields="product.customization" v-model="customization"></CustomizationAddProduct>

    <OptionalsAddProduct v-if="product && product.optionals && product.optionals.length > 0" :products="productsIndexed" :fields="product.optionals" v-model="optionals" :currency="currency"></OptionalsAddProduct>

    <div class="frame-parent4">
        <div class="detalles-aparecen-en-factura-wrapper">
            <div class="cantidad">Descripción (aparecen en factura)</div>
        </div>
        <div class="frame-wrapper3">
          <textarea v-model="description" class="agregue-los-detalles-correspon-wrapper" rows="4" placeholder="Agregue los detalles correspondientes al producto"></textarea>
        </div>
    </div>
    <div class="frame-parent5">
        <div class="frame-parent6" v-if="priceListItems.length">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Tipo de precio:</div>
            </div>
            <div class="wrapper1">
              <select class="div3" v-model="priceList">
                  <option v-for="item in priceListItems" :key="item" :value="item">{{item}}</option>
              </select>
            </div>
        </div>
        <div class="frame-parent6" v-if="false">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Precio base:</div>
            </div>
            <div class="wrapper1">
              <input type="number" class="div3" v-model.number="basePrice" />
            </div>
        </div>
        <div class="frame-parent6">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Adicionales:</div>
            </div>
            <div class="wrapper1">
              <input type="number" class="div3" readonly v-model.number="optionalsPrices" />
            </div>
        </div>
        <div class="frame-parent6">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Precio unitario:</div>
            </div>
            <div class="wrapper1">
              <input type="number" class="div3" v-model.number="unitPrice" />
            </div>
        </div>
        <div class="frame-parent6">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Precio total (sin IVA):</div>
            </div>
            <div class="wrapper1">
              <input type="number" class="div3" readonly :value="subtotal" />
            </div>
        </div>
        <div class="frame-parent6">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Descuento</div>
            </div>
            <div class="wrapper2">
              <input type="number" class="div3" v-model.number="discount" />
            </div>
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">%</div>
            </div>
        </div>
        <div class="frame-parent6">
            <div class="pregunta-de-seleccin-selecci-wrapper">
                <div class="cantidad">Precio IVAI:</div>
            </div>
            <div class="wrapper2">
              <input type="number" class="div3" readonly :value="total" />
            </div>
        </div>
    </div>
    <div class="boton-prinicipal"  @click="insertItem">
        <img class="group-icon1" alt="" src="../assets/Group2.svg">

        <div class="btn-text">Agregar producto</div>
    </div>
    <img class="productos-child" alt="" src="Line 10.svg"  v-if="false">

    <div class="buttonbtnprimary-colorbtn-r-wrapper" v-if="false">
        <div class="buttonbtnprimary-colorbtn-r">
            <div class="btn-text1">Guardar</div>
        </div>
    </div>
</div>
</template>
<script>
import firebaseApi from '../api/firebaseApi'
import CustomizationAddProduct from '../components/CustomizationAddProduct.vue'
import OptionalsAddProduct from '../components/OptionalsAddProduct.vue'
import CdAutocomplete from '@/components/cdInputs/CdAutocomplete.vue'
// import redaApp from '../api/redaApp'
import { mapGetters } from 'vuex'
function isObjectNotEmpty (obj) {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    Object.keys(obj).length > 0
  )
}
function decimalAdjust (type, value, exp) {
  // Si el exp no está definido o es cero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value)
  }
  value = +value
  exp = +exp
  // Si el valor no es un número o el exp no es un entero...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN
  }
  // Shift
  value = value.toString().split('e')
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)))
  // Shift back
  value = value.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp))
}
function round10 (value, exp) {
  return decimalAdjust('round', value, exp)
}
export default {
  name: 'AddProduct',
  props: {
    // currency: {
    //   type: String,
    //   default: 'CRC'
    // },
    // exchangeRate: {
    //   type: Number,
    //   default: 1
    // },
    // priceList: {
    //   type: String,
    //   default: 'general'
    // }
    // Aquí es donde se declararían las propiedades de tu componente
  },
  components: {
    CustomizationAddProduct,
    OptionalsAddProduct,
    CdAutocomplete
  },
  data () {
    return {
      length: 1,
      width: 1,
      quantityM2: 1,
      products: [],
      listenerProducts: null,
      search: null,
      product: null,
      group: null,
      discount: 0,
      description: null,
      lazyQuantity: 1,
      customization: {},
      // basePrice: 0,
      unitPrice: 0,
      optionals: [],
      priceList: 'general'
    }
  },
  computed: {
    basePrice () {
      if (!this.product) return 0
      const price = this.product?.prices.find(({ priceList }) => priceList === this.priceList) ||
        this.product?.prices[0]
      const exchangeRate = price?.currency === this.currency ? 1
        : price?.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      const margin = price?.margin
      const amount = Number(price?.price || 0)
      const unitCost = this.getMaterialCost(this.product?.commercialCode, this.currency, this.priceList)
      const unitPrice = (margin ? (Number(unitCost + this.optionalsPrices) * (1 + amount)) : (amount + this.optionalsPrices)) * exchangeRate
      const basePrice = price?.round ? Math.ceil(unitPrice) : Number(unitPrice.toFixed(2))
      return basePrice
    },
    // unitPrice () {
    //   if (!this.product) return 0
    //   return this.basePrice + this.optionalsPrices
    // },
    quantity: {
      get () {
        return this.product?.unit === 'm²'
          ? Number(this.length || 0) * Number(this.width || 0) * Number(this.quantityM2 || 0)
          : this.lazyQuantity
      },
      set (val) {
        this.lazyQuantity = Number(val || 0)
      }
    },
    priceListItems () {
      return this.product?.prices.map(({ priceList }) => priceList) || []
    },
    productsIndexed () {
      return this.products.reduce((acc, curr) => {
        acc[curr.commercialCode] = curr
        return acc
      }, {})
    },
    currency () {
      return this.$store.state[1].currency
    },
    exchangeRate () {
      return this.$store.state[1].exchangeRate
    },
    // priceList () {
    //   return this.$store.state[1].priceList
    // },
    items () {
      return this.products.filter((item) => this.customFilter(item, this.search))
    },
    subtotal () {
      const val = (this.totalUnitPrice * Number(this.quantity))
      return Number(val.toFixed(2))
    },
    optionalsPrices () {
      const optionals = this.product?.optionals || []
      return this.optionals?.reduce((acc, curr) => {
        const optional = optionals.find(({ code }) => (code === curr.code))
        const val = optional.type === 1 ? Number(optional?.value || 0)
          : optional.type === 2 ? Number(this.getPrice(optional.code)) : 0
        return acc + (val * Number(curr.quantity || 0))
      }, 0) || 0
    },
    totalUnitPrice () {
      const val = (this.unitPrice)
      return Number(val.toFixed(2))
    },
    total () {
      const total = this.subtotal - this.totalDiscount
      const rate = this.product?.taxes?.length ? Number(this.product.taxes[0].rate || 0) : 0
      const tax = 1 + (rate / 100)
      return Number((total * tax).toFixed(2))
    },
    totalDiscount  () {
      if (!Number(this.discount)) return 0
      return this.subtotal * (1 / (Number(this.discount) || 1))
    },
    ...mapGetters('company', [
      'getCompany'
    ]),
    ...mapGetters([
      'getExchangeRateUSD'
    ])
  },
  watch: {
    product (val) {
      Object.keys(this.customization).forEach(key => {
        this.$delete(this.customization, key)
      })
      if (!val) return
      if (val?.customization?.length) {
        for (let i = 0; i < val.customization.length; i++) {
          const field = val.customization[i]
          const fieldValue = field.default || (field.type === 'checkbox' ? [] : null)
          this.$set(this.customization, field.label, fieldValue)
        }
      }
      // const price = val?.prices?.find(({ priceList }) => priceList === this.priceList)
      // console.log(price)
      // const exchangeRate = price?.currency === this.currency ? 1
      //   : price?.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      // const margin = price?.margin
      // const amount = Number(price?.price || 0)
      // const unitCost = this.getMaterialCost(val.commercialCode, this.currency, this.priceList)
      // const basePrice = (margin ? (Number(unitCost) * (1 + amount)) : amount) * exchangeRate
      // this.basePrice = price?.round ? Math.ceil(basePrice) : Number(basePrice.toFixed(2))
      this.search = val?.description || null
      this.description = val?.description || null
    },
    optionalsPrices (val) {
      // const value = Number(val || 0)
      // const price = this.product?.prices.find(({ priceList }) => priceList === this.priceList) ||
      //   this.product?.prices[0]
      // console.log(price)
      // const exchangeRate = price?.currency === this.currency ? 1
      //   : price?.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      // const margin = price?.margin
      // const amount = Number(price?.price || 0)
      // const unitCost = this.getMaterialCost(this.product.commercialCode, this.currency, this.priceList)
      // const unitPrice = (margin ? (Number(unitCost + value) * (1 + amount)) : (amount + value)) * exchangeRate
      // this.unitPrice = price?.round ? Math.ceil(unitPrice) : Number(unitPrice.toFixed(2))
    },
    basePrice (val) {
      this.unitPrice = Number(val || 0)
    }
    // priceList (val) {
    //   const price = this.product?.prices.find(({ priceList }) => priceList === this.priceList) ||
    //     this.product?.prices[0]
    //   const exchangeRate = price?.currency === this.currency ? 1
    //     : price?.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
    //   const margin = price?.margin
    //   const amount = Number(price?.price || 0)
    //   const unitCost = this.getMaterialCost(this.product.commercialCode, this.currency, this.priceList)
    //   const basePrice = (margin ? (Number(unitCost) * (1 + amount)) : (amount)) * exchangeRate
    //   this.basePrice = price?.round ? Math.ceil(basePrice) : Number(basePrice.toFixed(2))
    // }
  },
  methods: {
    getPrice (code) {
      const val = this.productsIndexed[code]
      const price = val?.prices[0]
      const margin = price?.margin
      const amount = Number(price?.price || 0)
      const unitCost = this.getMaterialCost(val.commercialCode, this.currency, this.priceList)
      const exchangeRate = price?.currency === this.currency ? 1
        : price?.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      const unitPrice = (margin ? (Number(unitCost) * (1 + amount)) : amount) * exchangeRate
      return price?.round ? Math.ceil(unitPrice) : Number(unitPrice.toFixed(2))
    },
    cleanItem () {
      this.search = null
      this.product = null
      this.group = null
      this.unitPrice = 0
      this.discount = 0
      this.lazyQuantity = 1
      this.width = 1
      this.length = 1
      this.quantityM2 = 1
      this.description = null
      this.optionals = []
      this.priceList = 'general'
    },
    getMaterialCost (code, currency, pl = 'general') {
      const product = this.products.find(({ commercialCode }) => commercialCode === code)
      if (!product) console.log(code, [...this.products])
      let value = 0
      const price = product.prices?.length
        ? (product.prices.find(({ priceList }) => priceList === pl) || product.prices[0])
        : null
      const projectedCostCurrency = product.projectedCostCurrency || 'CRC'
      const exchangeRate = projectedCostCurrency === currency ? 1
        : projectedCostCurrency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
      const steps = product?.steps || []
      steps.forEach(step => {
        value += (step.drm?.reduce((acc, { material, quantity }) => {
          const materialCost = this.getMaterialCost(material, currency)
          acc += (materialCost * quantity)
          return acc
        }, 0) || 0)
      })
      if (product?.isMaterial && price && !value) {
        const exchangeRate = price.currency === currency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        return Number(price.price * exchangeRate)
      }
      return value
    },
    // getMaterialCost (code, currency, pl = 'general') {
    //   const product = this.products.find(({ commercialCode }) => commercialCode === code)
    //   let value = 0
    //   const price = product.prices?.length
    //     ? (product.prices.find(({ priceList }) => priceList === pl) || product.prices[0])
    //     : null
    //   const projectedCostCurrency = currency || product.projectedCostCurrency || price?.currency || 'CRC'
    //   const exchangeRate = projectedCostCurrency === price?.currency ? 1
    //     : projectedCostCurrency === 'USD' ? this.exchangeRate : (1 / this.exchangeRate)
    //   if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
    //   if (product?.isMaterial && price) {
    //     return Number(price.price * exchangeRate)
    //   }
    //   const steps = product?.steps || []
    //   steps.forEach(step => {
    //     value += (step.drm?.reduce((acc, { material, quantity }) => {
    //       const materialCost = this.getMaterialCost(material, projectedCostCurrency)
    //       acc += (materialCost * quantity)
    //       return acc
    //     }, 0) || 0)
    //   })
    //   console.log(code, value)
    //   return value
    // },
    insertItem: function () {
      if (this.product) {
        const currItems = this.$store.getters['1/getItems'] || []
        console.log(this.$store.getters['1/getVoucherType'])
        if (this.$store.getters['1/getVoucherType'] === '11') {
          const item = currItems.findIndex(({ commercialCode }) => (this.product.commercialCode === commercialCode))
          if (item > -1 && !this.optionals?.length) {
            if (!currItems[item].optionals?.length) {
              console.log(currItems[item])
              this.$store.commit('1/addQuantity', { index: item, quantity: round10(this.quantity, -5) })
              this.cleanItem()
              return
            }
          }
        }
        const newTaxes = {}
        const newItem = {}
        const area = {}
        const optionals = {}
        /* if (!this.checkStock({ code: this.tmp.item.code, quantity: round10(this.tmp.item.quantity, -5) })) {
          const errMsj = 'No hay suficientes productos codigo ' + this.tmp.item.code + ' en bodega.'
          this.showError(errMsj)
          return
        } /**/

        newItem.cabys = this.product.cabys
        newItem.commercialCode = this.product.commercialCode
        newItem.quantity = round10(this.quantity, -5)
        newItem.unit = this.product.unit
        newItem.description = this.description && this.description !== ''
          ? this.description : this.product.description
        newItem.price = { ...this.product.prices[0], price: this.totalUnitPrice }
        newItem.discountRate = this.discount || 0
        newItem.optionals = this.optionals || []
        if (this.product.unit === 'm²') {
          area['Largo en m'] = Number(this.length || 0)
          area['Ancho en m'] = Number(this.width || 0)
          area.Cantidad = Number(this.quantityM2 || 0)
        }
        if (this.optionals?.length) {
          for (let index = 0; index < this.optionals.length; index++) {
            const { code, quantity } = this.optionals[index]
            const product = this.products.find(({ commercialCode }) => commercialCode === code)
            optionals[product.description] = Number(quantity || 0)
          }
        }
        if (isObjectNotEmpty(this.customization)) {
          newItem.customization = {
            ...area,
            ...optionals,
            ...this.customization
          }
        }

        // unitPrice: Number(this.product.unitPrice)
        // total: this.itemSubtotal,
        // subtotal: this.itemSubtotal,
        // taxable_base: this.itemSubtotal,
        // tax_net: this.itemTaxNet,
        // netTotal: this.itemNetTotal,

        if (this.product.taxes && this.product.taxes.length > 0) {
          newTaxes.code = this.product.taxes[0].code
          newTaxes.rateCode = this.product.taxes[0].rateCode
          newTaxes.rate = this.product.taxes[0].rate
          newItem.taxes = [newTaxes]
        }
        // this.invoice.items.push(newItem)
        this.newItem({ ...newItem })
        this.cleanItem()
      }
    },
    newItem (payload) {
      this.$store.dispatch('1/newItem', payload)
    },
    customFilter (item, queryText, itemTitle) {
      try {
        const textOne = item.description.toLowerCase()
        const textTwo = item.commercialCode.toString()
        const searchText = queryText?.toString().toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      } catch (error) {
        console.error(error)
        console.log({ ...item })
      }
    },
    async reset () {
      if (this.listenerProducts) this.listenerProducts()
      // const res = await redaApp.getRedaApp('get-inventories')
      // const costs = res.data.products.reduce((acc, curr) => {
      //   acc[curr.commercialCode] = Number(curr.projectedCost || 0)
      //   return acc
      // }, {})
      this.listenerProducts = firebaseApi.db.collection('products')
        .where('company', '==', this.getCompany.identification)
        .onSnapshot(({ docs }) => {
          this.products = []
          for (let i = 0; i < docs.length; i++) {
            const doc = docs[i]
            const data = doc.data()
            // const materialsProjectedCost = data.steps?.length > 0 ? data.steps.reduce((acc, curr) => (
            //   acc + (curr.drm?.reduce((ac, cu) => (ac + (costs[cu.material] * cu.quantity)), 0) || 0)
            // ), 0) : 0
            // const unitCost = costs[data.commercialCode] || materialsProjectedCost || 0
            this.products.push({ ...data, uid: doc.id/* , unitCost */ })
          }
        })
    }
  },
  beforeCreate () {
    // Acciones antes de crear el componente
  },
  created () {
    // Acciones al crear el componente
  },
  beforeMount () {
    // Acciones antes de montar el componente
  },
  mounted () {
    this.reset()
  },
  beforeUpdate () {
    // Acciones antes de actualizar el componente
  },
  updated () {
    // Acciones al actualizar el componente
  },
  beforeDestroy () {
    this.listenerProducts()
  },
  destroyed () {
    // Acciones al destruir el componente
  }
}
</script>
<style scoped>
.datos-del-cliente {
    position: relative;
    line-height: 24px;
    font-weight: 500;
}
.titulo-seccion {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 0px;
    font-size: 24px;
    color: #480ca8;
    font-family: Rubik;
}
.vector-icon {
    width: 16.1px;
    position: relative;
    height: 16.1px;
}
.magebar-code-scan {
    width: 20.9px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2.1px;
    box-sizing: border-box;
}
.input-texto-quantity {
    width: 45px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: right;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.input-texto {
    width: 214px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: center;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.caja-de-texto {
    width: 230px;
    height: 21px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
}
.group-icon {
    width: 18.8px;
    position: relative;
    height: 18.8px;
}
.magebar-code-scan-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    text-align: center;
}
.desplegable {
    width: 62.3px;
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}
.icon-chevron {
    width: 10px;
    position: relative;
    height: 10px;
    overflow: hidden;
    flex-shrink: 0;
    object-fit: contain;
}
.desplegables {
    border-radius: 16px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 21px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    gap: 6px;
}
.cantidad {
    position: relative;
    font-weight: 500;
}
.div {
    position: relative;
}
.wrapper {
    border-radius: 8px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 8px;
    font-size: 11px;
    color: #979797;
}
.cantidad-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    font-size: 12px;
    color: #535763;
}
.frame-parent {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 20px;
    font-size: 11px;
    color: #979797;
}
.container {
    border-bottom: 1px solid #4361ee;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2px 8px;
    font-size: 11px;
    color: #979797;
}
.ancho-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
}
.frame-group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 8px 20px;
    gap: 17px;
    font-size: 12px;
}
.productos-child {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
}
.crea-tu-formulario {
    align-self: stretch;
    position: relative;
    font-size: 20px;
    letter-spacing: 0.16px;
    line-height: 25.11px;
    font-weight: 500;
    font-family: Rubik;
}
.pregunta-de-seleccin-selecci {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    padding-left: 21px;
}
.pregunta-de-seleccin-selecci-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.frame-div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.frame-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.custom-checkbox {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el estilo predeterminado del checkbox */
    cursor: pointer;
}
.custom-checkbox:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}
.custom-radio {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    display: inline-block;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    cursor: pointer;
}

/* Ocultar el input radio original */
.custom-radio input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

/* Estilo para cuando el radio button está seleccionado */
.custom-radio input[type="radio"]:checked + .custom-radio {
    background-color: #4361ee;
}
.frame-child {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el radio button original */
    cursor: pointer;
}

.frame-child:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}

.opcin-1-wrapper {
    width: 243.3px;
    border-radius: 8.37px;
    background-color: #ebf1ff;
    height: 23.7px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 6.3px 16.7px;
    box-sizing: border-box;
}
.ellipse-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
}
.frame-parent1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6.3px;
    font-size: 11px;
    color: #000;
}
.frame-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16.7px;
}
.rectangle-div {
    width: 18.8px;
    height: 18.8px;
    position: relative;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Remueve el estilo por defecto del checkbox */
    -webkit-appearance: none; /* Para compatibilidad con navegadores basados en WebKit */
    background-color: #fff; /* Fondo blanco para que parezca el div original */
    cursor: pointer; /* Añade un cursor de mano para simular el checkbox */
}

.rectangle-div:checked {
    background-color: #4361ee; /* Color de fondo al estar seleccionado */
}
.aadir-opcin {
    flex: 1;
    position: relative;
}
.detalles-aparecen-en-factura-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.agregue-los-detalles {
    margin: 0;
}
.agregue-los-detalles-correspon-wrapper {
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid #4361ee;
      padding: 6px 8px;
      display: block;
      resize: none; /* Evita que el usuario cambie el tamaño */
      font-family: inherit; /* Mantener la misma fuente */
      font-size: inherit; /* Mantener el tamaño de fuente */
}
.frame-wrapper3 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;
    color: #000;
}
.frame-parent4 {
    align-self: stretch;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
}
.div3 {
    width: 76.2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    background-color: transparent;
    text-align: center;
    appearance: none; /* Elimina estilos por defecto de input */
    -moz-appearance: textfield; /* Elimina flechas en Firefox */
}

.div3::-webkit-inner-spin-button,
.div3::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Elimina flechas en WebKit */
    margin: 0;
}
.wrapper1 {
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent6 {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}
.wrapper2 {
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent5 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    font-size: 12px;
    color: #535763;
}
.group-icon1 {
    width: 12.6px;
    position: relative;
    height: 12.6px;
}
.btn-text {
    position: relative;
    letter-spacing: 0.2px;
    line-height: 12.66px;
    font-weight: 500;
}
.boton-prinicipal {
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.25), 0px 4px 16px rgba(114, 9, 183, 0.1) inset;
    border-radius: 21.29px;
    background-color: #b5179e;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    gap: 6px;
    text-align: center;
    font-size: 11px;
    color: #fff;
    font-family: Rubik;
    cursor: pointer;
}
.btn-text1 {
    position: relative;
    letter-spacing: 0.12px;
    line-height: 13.24px;
    font-weight: 500;
}
.buttonbtnprimary-colorbtn-r {
    border-radius: 22.27px;
    background-color: #f72585;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8.4px 14.6px;
}
.buttonbtnprimary-colorbtn-r-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: center;
    font-size: 12.55px;
    color: #fff;
}
.productos {
    width: 100%;
    position: relative;
    border-radius: 20.92px;
    background-color: #fff;
    border: 1.5px solid #4361ee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 25.1px 24px;
    gap: 25.1px;
    text-align: left;
    font-size: 16px;
    color: #3f37c9;
    font-family: Roboto;
}
</style>
